<template>
  <div class="bg-white">
    <div class="max-w-5xl mx-auto text-center py-16 px-4 sm:space-y-4 sm:py-20 sm:px-6 lg:px-6">
      <div class="flow-root rounded-lg px-6 pb-8">
        <div class="-mt-6">
                    <span>
                    <i class="fal fa-sad-cry text-8xl text-blue-800 p3"></i>
                    </span>
        </div>
      </div>
      <div class="space-y-5 sm:mx-auto sm:max-w-lg sm:space-y-4 lg:max-w-5xl">
        <h2 class="text-3xl font-bold text-green-400 sm:text-4xl">
          Leider können wir Ihnen kein Angebot unterbreiten.
        </h2>
        <p class="mt-2 text-lg leading-6 text-gray-800">
          Unser Algorithmus hat Ihre Daten überprüft.<br> Wir können Ihnen derzeit leider keine Mietkautionsbürgschaft
          anbieten.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>
